// src/components/Testimonials.js
import React from "react";
import "./Testimonials.css";
import testimonials from "../data/testimonials.json";

// Featured quote leads full-width; the rest flow in a two-column wall below.
// (column-span requires the featured item first in source order.)
const ordered = [
  ...testimonials.filter((t) => t.featured),
  ...testimonials.filter((t) => !t.featured),
];

const Testimonials = () => (
  <ul className="testimonials">
    {ordered.map((testimonial, index) => (
      <li
        key={index}
        className={`testimonial${
          testimonial.featured ? " testimonial--featured" : ""
        }`}
      >
        <p className="testimonial__quote">{testimonial.text}</p>
        <p className="testimonial__author">{testimonial.author}</p>
      </li>
    ))}
  </ul>
);

export default Testimonials;
